import { AxisBottom, AxisLeft } from "@visx/axis";
import { GridRows } from "@visx/grid";
import { Group } from "@visx/group";
import XTick from "charts/lib/shared/XTick";
import YTick from "charts/lib/shared/YTick";
import { format } from "d3-format";
import React from "react";
import { useMedia } from "../../../../hooks";
import * as M from "../../../../materials";
import { breakpoints } from "../../../../materials/consts.stylex";
import { PADDING } from "../constants";
function Axis({ scaleX, scaleY, xAxisTitle, xAxisSubtitle, yAxisTitle, boundedWidth, boundedHeight }) {
    const isEmptyXAxis = scaleX.domain()[1] === -1;
    const xAxisTickValues = isEmptyXAxis ? [] : [
        ...Array(scaleX.domain()[1] - scaleX.domain()[0] + 1).keys()
    ].map((d)=>d + scaleX.domain()[0]);
    const screenMDown = !useMedia(breakpoints.m);
    return <Group>
      <GridRows width={boundedWidth} scale={scaleY} numTicks={5} stroke={M.divider}/>
      <AxisBottom top={PADDING.top + boundedHeight} scale={scaleX} stroke={M.divider} tickFormat={(value)=>{
        const formattedValue = format(".0f")(value);
        return value === scaleX.domain()[1] ? `${xAxisTitle} ${formattedValue}` : formattedValue;
    }} tickValues={screenMDown ? undefined : xAxisTickValues} numTicks={screenMDown ? Math.min(xAxisTickValues.length, 6) : xAxisTickValues.length} tickLength={0} tickLabelProps={(value, index)=>({
            ...bottomTickLabelProps,
            textAnchor: index === 0 ? "start" : value === scaleX.domain()[1] ? "end" : "middle"
        })} tickComponent={({ textAnchor, formattedValue, x })=><XTick textAnchor={textAnchor} label={formattedValue} transform={`translate(${x},${0})`}/>} label={isEmptyXAxis ? xAxisSubtitle : ""} labelProps={{
        ...M.fontAxisLabel.fontProps.cssProperties,
        fill: M.lightText,
        x: boundedWidth,
        textAnchor: "end",
        dy: "1.2em"
    }}/>
      <AxisLeft scale={scaleY} hideAxisLine numTicks={5} hideTicks hideZero tickFormat={(value)=>value === 1 ? `${format(".0%")(value)} ${yAxisTitle}` : format(".0f")(value * 100)} tickComponent={({ formattedValue, y })=>{
        if (formattedValue === "0") return null;
        return <YTick label={formattedValue} transform={`translate(${0},${y - 2})`}/>;
    }}/>
    </Group>;
}
export default React.memo(Axis);
const bottomTickLabelProps = {
    dy: "0.25em",
    fill: "#222",
    fontFamily: "Arial",
    fontSize: 10,
    textAnchor: "middle"
};
